module.exports = __webpack_public_path__ + "static/img/footer-wave.43082ae3.png";